var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#EAE3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2164 16.064C20.8344 11.67 16.2504 9.51403 16.0564 9.42603C15.8751 9.34078 15.6718 9.31354 15.4744 9.34803C10.1824 10.226 9.38641 13.306 9.35441 13.434C9.31087 13.6124 9.31779 13.7994 9.37441 13.974C15.6864 33.558 28.8044 37.188 33.1164 38.382C33.4484 38.474 33.7224 38.548 33.9304 38.616C34.1678 38.6936 34.4256 38.6786 34.6524 38.574C34.7844 38.514 37.9004 37.046 38.6624 32.258C38.6962 32.049 38.6626 31.8347 38.5664 31.646C38.4984 31.514 36.8684 28.412 32.3484 27.316C32.1951 27.2768 32.0345 27.2754 31.8805 27.312C31.7265 27.3486 31.5837 27.422 31.4644 27.526C30.0384 28.744 28.0684 30.042 27.2184 30.176C21.5204 27.39 18.3384 22.044 18.2184 21.03C18.1484 20.46 19.4544 18.458 20.9564 16.83C21.0508 16.7276 21.1227 16.6065 21.1675 16.4746C21.2123 16.3426 21.2289 16.2028 21.2164 16.064Z",
    fill: "#B2B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.d82a754d597eb9cd7f073bb2c998d47a.svg";
export { ForwardRef as ReactComponent };